import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('call');

const USE_LOG_ALL_ERRORS = true;

const DEFAULT_NAME = '** Unknown **';

const call = (name, fn, ...args) => {
  if (void 1 === fn) {
    // name isn't important if function was not provided, but is for displaying an error
    return void L.debug('()', 'Function fn:', fn, 'for name:', name, 'was not provided');
  }

  const n = fromAnyToString(name).trim() || DEFAULT_NAME;

  if (isNotFn(fn)) {
    // the idea is to not have to do try-catch, nor if-else for optional functions, but display an error anyway
    const e = new TypeError(`${n} is not a valid function`);
    return void L.error('()', 'Invalid function fn:', fn, 'for name:', n, 'Error:', e);
  }

  try {
    return fn(...args);
  } catch (e) {
    if (USE_LOG_ALL_ERRORS) L.warn('()', e);
    throw e;
  }
};

export default call;
